import { DEMO_STATUS, demoState, setDemoStatus } from '@/store/modules/demoMode';

const DEMO_STORAGE_KEY = 'demoMode';

const FIRST_NAMES = [
  'Maria', 'James', 'Sarah', 'David', 'Emily', 'Michael', 'Rachel', 'Robert',
  'Linda', 'William', 'Jennifer', 'Richard', 'Patricia', 'Thomas', 'Barbara',
  'Daniel', 'Susan', 'Matthew', 'Karen', 'Anthony', 'Nancy', 'Christopher',
  'Lisa', 'Andrew', 'Betty', 'Joseph', 'Dorothy', 'Charles', 'Sandra', 'Mark',
  'Ashley', 'Steven', 'Margaret', 'Paul', 'Donna', 'Kevin', 'Carol', 'Brian',
  'Ruth', 'George', 'Sharon', 'Timothy', 'Michelle', 'Ronald', 'Laura',
  'Edward', 'Kathleen', 'Jason', 'Amy', 'Jeffrey',
];

const LAST_NAMES = [
  'Chen', 'Whitfield', 'Martinez', 'Johnson', 'Anderson', 'Thompson', 'Garcia',
  'Robinson', 'Clark', 'Lewis', 'Walker', 'Hall', 'Allen', 'Young', 'King',
  'Wright', 'Hill', 'Scott', 'Adams', 'Baker', 'Nelson', 'Carter', 'Mitchell',
  'Perez', 'Roberts', 'Turner', 'Phillips', 'Campbell', 'Parker', 'Evans',
  'Edwards', 'Collins', 'Stewart', 'Morris', 'Reed', 'Cook', 'Morgan', 'Bell',
  'Murphy', 'Bailey', 'Rivera', 'Cooper', 'Richardson', 'Cox', 'Howard',
  'Ward', 'Torres', 'Peterson', 'Gray', 'Watson',
];

const PRACTICE_NAMES = [
  'Lakewood Primary Care', 'Summit Medical Group', 'Valley Health Associates',
  'Cedar Ridge Family Medicine', 'Riverside Medical Center', 'Maple Grove Clinic',
  'Evergreen Health Partners', 'Pinecrest Medical Associates', 'Beacon Hill Practice',
  'Clearwater Family Health', 'Harmony Medical Group', 'Oakdale Health Center',
  'Westside Primary Care', 'Northpoint Medical', 'Sunrise Health Partners',
  'Mountainview Clinic', 'Pacific Coast Medical', 'Heritage Family Practice',
  'Bayshore Health Group', 'Prairie Medical Associates', 'Crestview Health Center',
  'Harbor Medical Group', 'Meadowbrook Primary Care', 'Stonegate Family Medicine',
  'Bridgewater Health Partners', 'Fairview Medical Associates', 'Greenfield Clinic',
  'Crossroads Medical Group', 'Lakeshore Health Partners', 'Hillcrest Primary Care',
];

const FACILITY_NAMES = [
  'Memorial Regional Hospital', 'St. Joseph Medical Center', 'Community General Hospital',
  'Providence Health System', 'Good Samaritan Medical', 'Mercy Hospital',
  'United Health Center', 'Sacred Heart Hospital', 'Bayside Medical Center',
  'Summit Hospital', 'Northside Medical Center', 'Valley General Hospital',
  'Lakeview Regional', 'Trinity Health System', 'Riverside Community Hospital',
];

const PAYER_NAMES = [
  'Anthem Blue Cross', 'United Healthcare', 'Aetna', 'Cigna', 'Humana',
  'Kaiser Permanente', 'Blue Shield', 'Molina Healthcare', 'Centene',
  'WellCare', 'Magellan Health', 'Oscar Health', 'Bright Health',
];

const CONTRACT_NAMES = [
  'ACO REACH Global', 'ACO REACH Professional', 'MSSP Track 1+',
  'MSSP Enhanced Track', 'Direct Contracting Global', 'MA Value-Based',
  'Commercial Risk', 'Medicaid Managed Care', 'ACO REACH High Needs',
];

const STREET_NAMES = [
  'Oak', 'Maple', 'Cedar', 'Pine', 'Elm', 'Washington', 'Park', 'Lake',
  'Hill', 'Forest', 'River', 'Spring', 'Meadow', 'Sunset', 'Main',
];
const STREET_TYPES = ['St', 'Ave', 'Dr', 'Ln', 'Blvd', 'Ct', 'Rd', 'Way'];

const CITIES = [
  'Springfield', 'Riverside', 'Fairview', 'Georgetown', 'Madison',
  'Clinton', 'Franklin', 'Greenville', 'Bristol', 'Salem',
  'Manchester', 'Burlington', 'Ashland', 'Dayton', 'Oxford',
];

const STATES = [
  'AL', 'AZ', 'CA', 'CO', 'CT', 'FL', 'GA', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'MA', 'MD', 'MI', 'MN', 'MO', 'NC', 'NJ',
  'NM', 'NY', 'OH', 'OR', 'PA', 'SC', 'TN', 'TX', 'VA', 'WA',
];

const PHARMACY_NAMES = [
  'CVS Pharmacy', 'Walgreens', 'Rite Aid', 'Walmart Pharmacy',
  'Kroger Pharmacy', 'Costco Pharmacy', 'Publix Pharmacy',
  'Safeway Pharmacy', 'Target Pharmacy', 'HEB Pharmacy',
];

const TENANT_NAMES = [
  'Pinnacle Health Network', 'Atlas Care Partners', 'Meridian Health Alliance',
  'Vanguard Medical Group', 'Keystone Health Partners', 'Sterling Health Systems',
  'Compass Care Network', 'Summit Health Collaborative', 'Apex Medical Partners',
  'Horizon Care Alliance',
];

const UI_STOP_WORDS = new Set([
  'active', 'action', 'actions', 'all', 'annual', 'assessment', 'assigned',
  'attribution', 'average', 'board', 'care', 'category', 'chart', 'chronic',
  'claim', 'claims', 'clinical', 'code', 'coding', 'cohort', 'column',
  'completed', 'complex', 'condition', 'conditions', 'congestive', 'contact',
  'contract', 'contracts', 'cost', 'count', 'current', 'custom', 'daily',
  'dashboard', 'data', 'date', 'dates', 'day', 'days', 'default', 'department',
  'detail', 'details', 'diabetes', 'discharge', 'disease', 'domain', 'due',
  'edit', 'eligible', 'engaged', 'engagement', 'enrolled', 'enrollment',
  'entity', 'episode', 'episodes', 'error', 'event', 'events', 'evidence',
  'executive', 'export', 'facility', 'failure', 'filter', 'filters', 'finding',
  'findings', 'first', 'flag', 'flags', 'flow', 'follow', 'followup', 'form',
  'free', 'gap', 'gaps', 'general', 'global', 'goal', 'goals', 'graph',
  'group', 'groups', 'health', 'heart', 'high', 'history', 'home', 'hospice',
  'hospital', 'hypertension', 'impact', 'index', 'info', 'inpatient', 'insight',
  'insights', 'intake', 'intervention', 'issue', 'item', 'items', 'key', 'lab',
  'labs', 'last', 'lead', 'level', 'line', 'list', 'lists', 'live', 'lives',
  'load', 'loading', 'location', 'low', 'manage', 'management', 'manual',
  'map', 'market', 'master', 'measure', 'measures', 'med', 'medication',
  'medications', 'medium', 'meeting', 'meetings', 'member', 'members', 'metric',
  'metrics', 'mode', 'model', 'month', 'monthly', 'my', 'name', 'network',
  'new', 'next', 'no', 'none', 'normal', 'not', 'note', 'notes', 'null',
  'number', 'office', 'open', 'operations', 'opportunity', 'option', 'options',
  'order', 'other', 'outpatient', 'outreach', 'overall', 'overview', 'owner',
  'page', 'pages', 'panel', 'part', 'partner', 'partners', 'patient',
  'patients', 'payer', 'payers', 'pending', 'per', 'performance', 'period',
  'phone', 'physician', 'plan', 'plans', 'play', 'playbook', 'point', 'pool',
  'population', 'portal', 'post', 'practice', 'practices', 'Preferred',
  'primary', 'priority', 'private', 'problem', 'problems', 'program',
  'programs', 'project', 'projects', 'provider', 'providers', 'public',
  'quality', 'queue', 'rate', 'rates', 'readmission', 'reason', 'recapture',
  'recent', 'record', 'records', 'red', 'referral', 'region', 'registry',
  'renal', 'report', 'reports', 'request', 'result', 'results', 'review',
  'risk', 'role', 'roles', 'roster', 'route', 'rule', 'rules', 'run', 'runs',
  'savings', 'schedule', 'scheduled', 'score', 'scorecard', 'scores', 'search',
  'section', 'select', 'selected', 'service', 'services', 'session', 'sessions',
  'setting', 'settings', 'shared', 'signal', 'signals', 'site', 'sites',
  'snapshot', 'sort', 'source', 'sources', 'special', 'specialty', 'staff',
  'stage', 'standard', 'star', 'stars', 'start', 'state', 'status', 'step',
  'study', 'subject', 'summary', 'support', 'survey', 'suspect', 'suspects',
  'system', 'tab', 'table', 'tag', 'tags', 'target', 'task', 'tasks', 'team',
  'teams', 'template', 'tenant', 'test', 'text', 'theme', 'themes', 'therapy',
  'tier', 'time', 'timeline', 'tin', 'title', 'to', 'today', 'top', 'total',
  'track', 'tracker', 'tranche', 'transcript', 'transition', 'transitions',
  'trend', 'triage', 'type', 'types', 'unassigned', 'unknown', 'up', 'update',
  'upload', 'user', 'users', 'utilization', 'value', 'values', 'version',
  'view', 'views', 'visit', 'visits', 'vital', 'vitals', 'voice', 'voicemail',
  'volume', 'week', 'weekly', 'wellness', 'widget', 'widgets', 'window',
  'work', 'workflow', 'workflows', 'worklist', 'year', 'yearly', 'yes', 'ytd',
  'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august',
  'september', 'october', 'november', 'december', 'jan', 'feb', 'mar', 'apr',
  'jun', 'jul', 'aug', 'sep', 'sept', 'oct', 'nov', 'dec', 'mon', 'tue', 'wed',
  'thu', 'fri', 'sat', 'sun',
]);

const BRAND_WORDS = { vytalize: 'Northstar', vytal: 'Vital' };
const BRAND_RE = /vytalize|vytal/gi;

function matchCase(source, word) {
  if (source === source.toUpperCase()) return word.toUpperCase();
  if (source === source.toLowerCase()) return word.toLowerCase();
  return word;
}

function applyBrand(text) {
  if (!text || !/vytal/i.test(text)) return text;
  return text.replace(BRAND_RE, (m) => matchCase(m, BRAND_WORDS[m.toLowerCase()]));
}

function djb2(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function pick(arr, seed) {
  return arr[seed % arr.length];
}

function spoofPhone(seed) {
  const area = 200 + (seed % 700);
  const mid = 200 + ((seed >> 8) % 700);
  const end = 1000 + ((seed >> 16) % 9000);
  return `(${area}) ${mid}-${end}`;
}

function spoofMbi(seed) {
  const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const digits = '0123456789';
  let mbi = '';
  const pattern = [digits, letters, letters, digits, letters, letters, digits, letters, letters, digits, digits];
  for (let i = 0; i < pattern.length; i++) {
    const pool = pattern[i];
    mbi += pool[(seed + i * 7) % pool.length];
  }
  return mbi;
}

function spoofNpi(seed) {
  let npi = '1';
  for (let i = 1; i < 10; i++) {
    npi += String((seed + i * 3) % 10);
  }
  return npi;
}

function spoofTin(seed) {
  const p1 = String(10 + (seed % 90));
  let p2 = '';
  for (let i = 0; i < 7; i++) {
    p2 += String((seed + i * 11) % 10);
  }
  return `${p1}-${p2}`;
}

function spoofSsn(seed) {
  const a = String(100 + (seed % 800));
  const b = String(10 + ((seed >> 8) % 90));
  const c = String(1000 + ((seed >> 16) % 9000));
  return `${a}-${b}-${c}`;
}

function spoofEmail(seed) {
  const first = pick(FIRST_NAMES, seed).toLowerCase();
  const last = pick(LAST_NAMES, seed >> 4).toLowerCase();
  const domains = ['gmail.com', 'yahoo.com', 'outlook.com', 'mail.com'];
  return `${first}.${last}@${pick(domains, seed >> 8)}`;
}

function spoofAddress(seed) {
  const num = 100 + (seed % 9900);
  const street = pick(STREET_NAMES, seed >> 4);
  const type = pick(STREET_TYPES, seed >> 8);
  const city = pick(CITIES, seed >> 12);
  const state = pick(STATES, seed >> 16);
  const zip = String(10000 + (seed % 90000));
  return `${num} ${street} ${type}, ${city}, ${state} ${zip}`;
}

function spoofZip(seed) {
  return String(10000 + (seed % 90000));
}

function spoofDate(seed, original = '') {
  const month = String(1 + (seed % 12)).padStart(2, '0');
  const day = String(1 + ((seed >> 4) % 28)).padStart(2, '0');
  const isoMatch = typeof original === 'string' && original.match(/^(\d{4})-\d{2}-\d{2}/);
  if (isoMatch) {
    return `${isoMatch[1]}-${month}-${day}`;
  }
  const yearMatch = typeof original === 'string' && original.match(/\b(19\d{2}|20\d{2})\b/);
  const year = yearMatch ? yearMatch[1] : String(1945 + ((seed >> 8) % 55));
  return `${month}/${day}/${year}`;
}

function spoofIdentifier(text, seed) {
  const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  let out = '';
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (ch >= '0' && ch <= '9') {
      out += String((seed + i * 7 + ch.charCodeAt(0)) % 10);
    } else if (ch >= 'A' && ch <= 'Z') {
      out += letters[(seed + i * 11 + ch.charCodeAt(0)) % letters.length];
    } else if (ch >= 'a' && ch <= 'z') {
      out += letters[(seed + i * 11 + ch.charCodeAt(0)) % letters.length].toLowerCase();
    } else {
      out += ch;
    }
  }
  return out;
}

const nameTokenMap = new Map();
let nameTokenRegex = null;
let nameTokenDirty = false;
let nameMapVersion = 0;

function fakeForToken(token, role) {
  const clean = token.replace(/[^A-Za-z'-]/g, '');
  if (!clean) return token;
  const key = clean.toLowerCase();
  const existing = nameTokenMap.get(key);
  if (existing) return matchCase(token, existing);
  const h = djb2(key);
  let fake;
  if (role === 'last') fake = pick(LAST_NAMES, h);
  else if (role === 'first') fake = pick(FIRST_NAMES, h);
  else fake = pick(h % 2 === 0 ? FIRST_NAMES : LAST_NAMES, h);
  nameTokenMap.set(key, fake);
  nameTokenDirty = true;
  nameMapVersion++;
  return matchCase(token, fake);
}

function rebuildNameRegex() {
  nameTokenDirty = false;
  if (nameTokenMap.size === 0) {
    nameTokenRegex = null;
    return;
  }
  const keys = [...nameTokenMap.keys()]
    .filter((k) => k.length >= 2 && !UI_STOP_WORDS.has(k))
    .sort((a, b) => b.length - a.length)
    .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  nameTokenRegex = keys.length ? new RegExp('\\b(' + keys.join('|') + ')\\b', 'gi') : null;
}

function applyNameTokens(text) {
  if (nameTokenDirty) rebuildNameRegex();
  if (!nameTokenRegex) return text;
  return text.replace(nameTokenRegex, (m) => {
    const fake = nameTokenMap.get(m.toLowerCase());
    if (!fake) return m;
    if (m[0] === m[0].toLowerCase()) return m;
    return matchCase(m, fake);
  });
}

function spoofPersonLastFirst(last, first) {
  return `${fakeForToken(last, 'last')}, ${fakeForToken(first, 'first')}`;
}

function spoofPersonFirstLast(first, last) {
  return `${fakeForToken(first, 'first')} ${fakeForToken(last, 'last')}`;
}

function spoofPersonExplicit(text) {
  const trimmed = text.trim();
  if (!trimmed || isPlaceholder(trimmed)) return text;
  let m = trimmed.match(LAST_FIRST_RE);
  if (m) return spoofPersonLastFirst(m[1], m[2]);
  m = trimmed.match(TITLE_SURNAME_RE);
  if (m) return `${m[1]} ${fakeForToken(m[2], 'last')}`;
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return fakeForToken(parts[0], 'first');
  const first = fakeForToken(parts[0], 'first');
  const last = fakeForToken(parts[parts.length - 1], 'last');
  return `${first} ${last}`;
}

const PHONE_RE = /^[\s(]*\d{3}[\s).-]+\d{3}[\s.-]+\d{4}\s*$/;
const MBI_RE = /^[0-9][A-Z][A-Z0-9]{2}-?[A-Z0-9]{3}-?[A-Z0-9]{4}$/i;
const NPI_RE = /^[12]\d{9}$/;
const TIN_RE = /^\d{2}-\d{7}$/;
const SSN_RE = /^\d{3}-\d{2}-\d{4}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const DATE_RE = /^(\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}|\w{3}\s+\d{1,2},?\s+\d{4}|\d{4}-\d{2}-\d{2})$/;
const ZIP_RE = /^\d{5}(-\d{4})?$/;
const ADDRESS_RE = /^\d+\s+\w+.*\b(st|ave|dr|ln|blvd|ct|rd|way|street|avenue|drive|lane|boulevard|court|road|circle)\b/i;

const EMBEDDED_RES = [
  { re: /[^\s@]+@[^\s@]+\.[^\s@]+/g, fn: (s, m) => spoofEmail(s) },
  { re: /\(?\d{3}\)?[\s.-]+\d{3}[\s.-]+\d{4}/g, fn: (s, m) => spoofPhone(s) },
  { re: /\b\d{3}-\d{2}-\d{4}\b/g, fn: (s, m) => spoofSsn(s) },
  { re: /\b\d{2}-\d{7}\b/g, fn: (s, m) => spoofTin(s) },
  { re: /\b[12]\d{9}\b/g, fn: (s, m) => spoofNpi(s) },
  { re: /\b[0-9][A-Z][A-Z0-9]{2}-?[A-Z0-9]{3}-?[A-Z0-9]{4}\b/gi, fn: (s, m) => spoofMbi(s) },
  { re: /\b\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}\b/g, fn: (s, m) => spoofDate(s, m) },
  { re: /\b\d{4}-\d{2}-\d{2}\b/g, fn: (s, m) => spoofDate(s, m) },
];

function transformFreeText(text) {
  let result = text;
  for (const { re, fn } of EMBEDDED_RES) {
    result = result.replace(re, (m) => fn(djb2(m), m));
  }
  result = applyNameTokens(result);
  return applyBrand(result);
}

const LAST_FIRST_RE = /^([A-Z][A-Za-z'’-]+),\s*([A-Z][A-Za-z'’-]+)\b/;
const TITLE_SURNAME_RE = /^((?:Dr|Mr|Mrs|Ms|Doctor|Prof)\.?)\s+([A-Z][A-Za-z'’-]+)$/;
const FIRST_LAST_RE = /^([A-Z][A-Za-z'’-]+)\s+([A-Z][A-Za-z'’-]+)$/;

function isPlaceholder(trimmed) {
  return !trimmed || /^[-–—]+$/.test(trimmed) || /^n\/a$/i.test(trimmed);
}

function spoofTenantName(text) {
  const trimmed = text.trim();
  if (isPlaceholder(trimmed)) return text;
  const branded = applyBrand(trimmed);
  return branded !== trimmed ? branded : pick(TENANT_NAMES, djb2(trimmed));
}

function kindFromElement(el) {
  if (!el?.getAttribute) return null;
  const attr = el.getAttribute('data-spoof-kind');
  if (attr) return attr;
  const cls = typeof el.className === 'string' ? el.className : '';
  const m = cls.match(/\bspoof-kind-([a-z-]+)\b/);
  return m ? m[1] : null;
}

function spoofByKind(text, kind) {
  const trimmed = text.trim();
  if (isPlaceholder(trimmed)) return text;
  const seed = djb2(trimmed);
  switch (kind) {
    case 'person':
    case 'provider':
      return spoofPersonExplicit(trimmed);
    case 'person-first':
      return fakeForToken(trimmed, 'first');
    case 'person-last':
      return fakeForToken(trimmed, 'last');
    case 'practice':
      return pick(PRACTICE_NAMES, seed);
    case 'facility':
      return pick(FACILITY_NAMES, seed);
    case 'payer':
      return pick(PAYER_NAMES, seed);
    case 'contract':
      return pick(CONTRACT_NAMES, seed);
    case 'tenant':
      return spoofTenantName(trimmed);
    case 'identifier':
      if (MBI_RE.test(trimmed)) return spoofMbi(seed);
      if (NPI_RE.test(trimmed)) return spoofNpi(seed);
      if (TIN_RE.test(trimmed)) return spoofTin(seed);
      if (SSN_RE.test(trimmed)) return spoofSsn(seed);
      return spoofIdentifier(trimmed, seed);
    case 'dob':
    case 'date':
      return spoofDate(seed, trimmed);
    case 'phone':
      return spoofPhone(seed);
    case 'email':
      return spoofEmail(seed);
    case 'address':
      return spoofAddress(seed);
    case 'zip':
      return spoofZip(seed);
    case 'label':
      return transformFreeText(text);
    default:
      return detectAndSpoof(text);
  }
}

function spoofForElement(el, text) {
  const kind = kindFromElement(el);
  return kind ? spoofByKind(text, kind) : detectAndSpoof(text);
}

function detectAndSpoof(text) {
  const trimmed = text.trim();
  if (isPlaceholder(trimmed)) return text;

  const seed = djb2(trimmed);

  if (PHONE_RE.test(trimmed)) return spoofPhone(seed);
  if (MBI_RE.test(trimmed)) return spoofMbi(seed);
  if (NPI_RE.test(trimmed)) return spoofNpi(seed);
  if (TIN_RE.test(trimmed)) return spoofTin(seed);
  if (SSN_RE.test(trimmed)) return spoofSsn(seed);
  if (EMAIL_RE.test(trimmed)) return spoofEmail(seed);
  if (ZIP_RE.test(trimmed)) return spoofZip(seed);
  if (DATE_RE.test(trimmed)) return spoofDate(seed, trimmed);
  if (ADDRESS_RE.test(trimmed)) return spoofAddress(seed);

  let m = trimmed.match(LAST_FIRST_RE);
  if (m) return spoofPersonLastFirst(m[1], m[2]);

  m = trimmed.match(TITLE_SURNAME_RE);
  if (m) return `${m[1]} ${fakeForToken(m[2], 'last')}`;

  if (trimmed.length <= 60) {
    if (/\b(pharmacy|rx|drug)\b/i.test(trimmed)) return pick(PHARMACY_NAMES, seed);
    if (/\b(hospital|regional|medical center)\b/i.test(trimmed)) return pick(FACILITY_NAMES, seed);
    if (/\b(medical|health|clinic|care|practice|group|center|associates|partners|family|primary)\b/i.test(trimmed)) {
      return pick(PRACTICE_NAMES, seed);
    }
    if (/\b(ACO|MSSP|contract|managed|risk|track)\b/i.test(trimmed)) return pick(CONTRACT_NAMES, seed);
    if (/\b(aetna|cigna|humana|united|anthem|blue|shield|molina|centene|wellcare|medicare|medicaid)\b/i.test(trimmed)) {
      return pick(PAYER_NAMES, seed);
    }
    if (/\b(network|alliance|collaborative|systems|vytalize|privia|agilon|aledade|oak\s*street|chenmed)\b/i.test(trimmed)) {
      return spoofTenantName(trimmed);
    }
    m = trimmed.match(FIRST_LAST_RE);
    if (
      m &&
      !UI_STOP_WORDS.has(m[1].toLowerCase()) &&
      !UI_STOP_WORDS.has(m[2].toLowerCase())
    ) {
      return spoofPersonFirstLast(m[1], m[2]);
    }
  }

  return transformFreeText(text);
}

export function spoofText(str, kind = null) {
  if (str == null) return str;
  const text = String(str);
  if (!text.trim()) return text;
  try {
    return kind ? spoofByKind(text, kind) : detectAndSpoof(text);
  } catch {
    return text;
  }
}

export function demoLabel(value, kind = null) {
  return isDemoMode() ? spoofText(value, kind) : value;
}

export function sensitiveCell(kind = null) {
  return kind ? `sensitive spoof-kind-${kind}` : 'sensitive';
}

export function entitySpoofKind(type, name = '') {
  if (/^\d{4}$/.test(String(name).trim())) return 'label';
  const t = String(type || '').toLowerCase();
  if (t === 'tin') return 'identifier';
  if (t.includes('patient') || t.includes('staff') || t.includes('analyst') || t.includes('coder') || t.includes('coordinator') || t === 'ptm' || t === 'rmo') {
    return 'person';
  }
  if (t.includes('provider') || t.includes('physician')) return 'provider';
  if (t.includes('facility') || t.includes('hospital')) return 'facility';
  if (t.includes('payer')) return 'payer';
  if (t.includes('contract') || t.includes('aco') || t.includes('pool')) return 'contract';
  if (t.includes('tenant') || t.includes('organization') || t.includes('network')) return 'tenant';
  return 'practice';
}

// --- DOM processing ---

const originals = new WeakMap();
const rescanList = new Set();
const SENSITIVE_ATTRS = ['title', 'aria-label', 'alt', 'placeholder'];

function processAttributes(el, entry) {
  if (!entry.attrs) entry.attrs = {};
  for (const attr of SENSITIVE_ATTRS) {
    if (!el.hasAttribute(attr)) continue;
    const current = el.getAttribute(attr);
    if (!current || !current.trim()) continue;
    const rec = entry.attrs[attr];
    if (rec && current === rec.spoofed) continue;
    const spoofed = applyBrand(spoofForElement(el, current));
    if (spoofed === current) continue;
    entry.attrs[attr] = { original: current, spoofed };
    el.setAttribute(attr, spoofed);
  }
}

function processElement(el) {
  try {
    processElementUnsafe(el);
  } catch {
    /* ignore */
  }
}

function processElementUnsafe(el) {
  const entry = originals.get(el) || {};
  const children = el.children;
  const original = el.textContent;
  const hasText = original && original.trim();

  if (!hasText) {
    if (!entry.type) entry.type = 'empty';
  } else if (children.length === 0) {
    const isOurs = entry.type === 'text' && original === entry.spoofed;
    if (!isOurs) {
      const spoofed = spoofForElement(el, original);
      entry.type = 'text';
      entry.value = original;
      entry.spoofed = spoofed;
      if (spoofed !== original) {
        el.textContent = spoofed;
      }
      if (/\s/.test(original) && original.length > 20) rescanList.add(el);
      else rescanList.delete(el);
    }
  } else {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    const byNode = new Map((entry.nodes || []).map((r) => [r.node, r]));
    const present = [];
    let node;
    while ((node = walker.nextNode())) {
      const cur = node.textContent;
      if (!cur.trim()) continue;
      let rec = byNode.get(node);
      if (rec && cur === rec.spoofed) {
        present.push(rec);
        continue;
      }
      const spoofed = spoofForElement(node.parentElement || el, cur);
      if (!rec) rec = { node, original: cur };
      else rec.original = cur;
      if (spoofed !== cur) {
        node.textContent = spoofed;
        rec.spoofed = spoofed;
      } else {
        rec.spoofed = cur;
      }
      present.push(rec);
    }
    if (present.length > 0) {
      entry.type = 'nodes';
      entry.nodes = present;
      rescanList.add(el);
    }
  }

  processAttributes(el, entry);
  originals.set(el, entry);
  el.setAttribute('data-spoofed', '');
}

function restoreElement(el) {
  const saved = originals.get(el);
  if (!saved) return;

  if (saved.type === 'text') {
    el.textContent = saved.value;
  } else if (saved.type === 'nodes' && saved.nodes) {
    for (const { node, original } of saved.nodes) {
      node.textContent = original;
    }
  }
  if (saved.attrs) {
    for (const attr of SENSITIVE_ATTRS) {
      if (saved.attrs[attr]) el.setAttribute(attr, saved.attrs[attr].original);
    }
  }
  el.removeAttribute('data-spoofed');
  originals.delete(el);
}

function processAll() {
  document.querySelectorAll('.sensitive').forEach(processElement);
}

function rescanFreeText() {
  for (const el of rescanList) {
    if (!el.isConnected) {
      rescanList.delete(el);
      continue;
    }
    const entry = originals.get(el);
    if (!entry) {
      rescanList.delete(el);
      continue;
    }
    if (entry.type === 'text') {
      const t = spoofForElement(el, entry.value);
      if (el.textContent !== t) {
        entry.spoofed = t;
        el.textContent = t;
      }
    } else if (entry.type === 'nodes' && entry.nodes) {
      for (const rec of entry.nodes) {
        if (!rec.node.isConnected) continue;
        const t = spoofForElement(rec.node.parentElement || el, rec.original);
        if (rec.node.textContent !== t) {
          rec.spoofed = t;
          rec.node.textContent = t;
        }
      }
    }
  }
}

function rescanIfLearned(versionBefore) {
  if (nameMapVersion === versionBefore) return;
  let guard = 0;
  let v;
  do {
    v = nameMapVersion;
    rescanFreeText();
  } while (nameMapVersion !== v && ++guard < 5);
}

const brandedText = new Map();
const BRAND_SKIP = '.sensitive, [data-spoofed], script, style, textarea';

function brandTextNode(node) {
  if (!node.nodeValue || !/vytal/i.test(node.nodeValue)) return;
  if (node.parentElement?.closest(BRAND_SKIP)) return;
  if (!brandedText.has(node)) brandedText.set(node, node.nodeValue);
  node.nodeValue = applyBrand(node.nodeValue);
}

function brandSubtree(root) {
  if (!root) return;
  if (root.nodeType === 3) {
    brandTextNode(root);
    return;
  }
  if (root.nodeType !== 1 || !/vytal/i.test(root.textContent || '')) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
  let n = walker.nextNode();
  while (n) {
    brandTextNode(n);
    n = walker.nextNode();
  }
}

function restoreBrand() {
  brandedText.forEach((original, node) => {
    if (node.isConnected) node.nodeValue = original;
  });
  brandedText.clear();
}

function restoreAll() {
  document.querySelectorAll('[data-spoofed]').forEach(restoreElement);
}

let observer = null;

const OBSERVE_OPTS = {
  childList: true,
  subtree: true,
  characterData: true,
  attributes: true,
  attributeFilter: SENSITIVE_ATTRS,
};

function collectTargets(mutations, sensitive, branded) {
  for (const m of mutations) {
    if (m.type === 'childList') {
      for (const n of m.addedNodes) {
        branded.add(n);
        if (n.nodeType === 1) {
          if (n.classList?.contains('sensitive')) sensitive.add(n);
          n.querySelectorAll?.('.sensitive').forEach((e) => sensitive.add(e));
        } else if (n.nodeType === 3) {
          const el = n.parentElement?.closest('.sensitive');
          if (el) sensitive.add(el);
        }
      }
    } else if (m.type === 'characterData') {
      branded.add(m.target);
      const el = m.target.parentElement?.closest('.sensitive');
      if (el) sensitive.add(el);
    } else if (m.type === 'attributes') {
      if (m.target.classList?.contains('sensitive')) sensitive.add(m.target);
    }
  }
}

function flush(mutations) {
  const sensitive = new Set();
  const branded = new Set();
  collectTargets(mutations, sensitive, branded);
  if (sensitive.size === 0 && branded.size === 0) return;
  observer.disconnect();
  try {
    const version = nameMapVersion;
    sensitive.forEach(processElement);
    rescanIfLearned(version);
    branded.forEach(brandSubtree);
  } finally {
    observer.takeRecords();
    observer.observe(document.body, OBSERVE_OPTS);
  }
}

export function isDemoMode() {
  if (demoState.status !== DEMO_STATUS.OFF) return true;
  try {
    return typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function' && localStorage.getItem(DEMO_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function activateSpoof() {
  if (observer || typeof document === 'undefined' || !document.body) return;
  try {
    const version = nameMapVersion;
    processAll();
    rescanIfLearned(version);
    brandSubtree(document.body);
    observer = new MutationObserver(flush);
    observer.observe(document.body, OBSERVE_OPTS);
  } catch {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }
}

export function deactivateSpoof() {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
  if (typeof document !== 'undefined') {
    restoreAll();
    restoreBrand();
  }
  rescanList.clear();
  nameTokenMap.clear();
  nameTokenRegex = null;
  nameTokenDirty = false;
  nameMapVersion = 0;
}

function clearLegacyDemoKeys() {
  try {
    sessionStorage.removeItem('demoModeSession');
    sessionStorage.removeItem('demoBootRecord');
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && (k.startsWith('demoModeLease:') || k.startsWith('demoModeRouteToken:'))) {
        toRemove.push(k);
      }
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}

export function setDemoMode(enabled) {
  const on = Boolean(enabled);
  try {
    if (typeof localStorage !== 'undefined' && typeof localStorage.setItem === 'function') {
      if (on) localStorage.setItem(DEMO_STORAGE_KEY, 'true');
      else localStorage.removeItem(DEMO_STORAGE_KEY);
    }
  } catch {
    /* ignore */
  }
  setDemoStatus(on ? DEMO_STATUS.READY : DEMO_STATUS.OFF);
  if (typeof document !== 'undefined' && document.body) {
    document.body.classList.toggle('demo-mode', on);
  }
  if (on) activateSpoof();
  else deactivateSpoof();
}

export function toggleDemoMode() {
  setDemoMode(!isDemoMode());
}

export function initDemoMode(appStore = null) {
  clearLegacyDemoKeys();
  let initial = false;
  try {
    initial = typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function' && localStorage.getItem(DEMO_STORAGE_KEY) === 'true';
  } catch {
    initial = false;
  }
  if (initial) {
    setDemoMode(true);
  }
  if (appStore?.subscribe) {
    appStore.subscribe((mutation) => {
      if (mutation.type === 'auth/CLEAR_USER') {
        if (isDemoMode()) setDemoMode(false);
      } else if (mutation.type === 'auth/SET_USER') {
        const user = mutation.payload;
        if (user && !user.is_superuser && isDemoMode()) {
          setDemoMode(false);
        }
      }
    });
  }
}
